import { StyleSheet } from 'react-native';
import { AppText } from '@/components/AppText';
import { TextProps } from 'react95-native-rabbl/src/components/Typography/Text';
import { withTheme } from 'react95-native-rabbl/src/core/theming';
import * as AppConsts from '@/utilities/AppConsts';

const CustomTextBaseStyles = StyleSheet.create({
  default: {
    color: AppConsts.LINK_COLOR,
    textShadowColor: AppConsts.LINK_SHADOW_COLOR,
    textShadowOffset: {
      width: 3,
      height: 3,
    },
    textShadowRadius: 1,
    fontStyle: 'italic',
    fontWeight: 'bold',
    letterSpacing: 5,
    fontSize: 20,
    flexShrink: 1,
  },
  link: {
    color: AppConsts.LINK_COLOR,
    fontSize: 18,
    textDecorationColor: AppConsts.LINK_COLOR,
    textDecorationLine: 'underline',
    fontStyle: 'italic',
  },
});

export const CustomTextStyles = StyleSheet.create({
  default: {
    ...CustomTextBaseStyles.default,
  },
  normal: {
    ...CustomTextBaseStyles.default,
    fontSize: AppConsts.DEFAULT_FONT_SIZE,
  },
  normalUnderline: {
    ...CustomTextBaseStyles.default,
    fontSize: AppConsts.DEFAULT_FONT_SIZE,
    textDecorationLine: 'underline',
  },
  tiny: {
    ...CustomTextBaseStyles.default,
    fontSize: 8,
  },
  small: {
    ...CustomTextBaseStyles.default,
    fontSize: 12,
  },
  medium: {
    ...CustomTextBaseStyles.default,
    fontSize: 16,
  },
  headerTitle: {
    ...CustomTextBaseStyles.default,
  },
  large: {
    ...CustomTextBaseStyles.default,
    fontSize: 30,
  },
  highlight: {
    color: AppConsts.LINK_COLOR,
    fontSize: 18,
    textShadowColor: AppConsts.LINK_SHADOW_COLOR,
    textShadowOffset: {
      width: 3,
      height: 3,
    },
  },
  link: {
    ...CustomTextBaseStyles.link,
  },
  linkTinyNoUnderline: {
    ...CustomTextBaseStyles.link,
    fontSize: 8,
    textDecorationLine: 'none',
  },
  linkSuperTinyNoUnderline: {
    ...CustomTextBaseStyles.link,
    fontSize: 7,
    textDecorationLine: 'none',
  },
  linkSmall: {
    ...CustomTextBaseStyles.link,
    fontSize: 12,
  },
});

type Props = {
  type?: 'default' | 'link' | 'highlight' | 'large',
} & TextProps;

export const CustomText = withTheme(({ style, children, type = 'default', ...inputProps }: Props) => {
  let finalStyle: any = CustomTextStyles.default;
  switch (type) {
    case 'default':
      finalStyle = CustomTextStyles.default;
      break;
    case 'link':
      finalStyle = CustomTextStyles.link;
      break;
    case 'highlight':
      finalStyle = CustomTextStyles.highlight;
      break;
    case 'large':
      finalStyle = CustomTextStyles.large;
      break;
  }
  return (
    <AppText
      style={[
        finalStyle,
        style,
      ]}
      {...inputProps}
    >
      {children}
    </AppText>
  );
});
